export const REACTION_SETS: {id: string, i18nKey: string, options: {id: string, emoji: string, i18nKey: string}[]}[] = [
    { 
        id: "news", 
        i18nKey: "liveblog.reactions.news.title",
        options: [
            { id: "heart", emoji: "❤️", i18nKey: "liveblog.reactions.generic.heart" },
            { id: "surprised", emoji: "😮", i18nKey: "liveblog.reactions.generic.surprised" },
            { id: "idea", emoji: "💡", i18nKey: "liveblog.reactions.generic.idea" },
            { id: "question", emoji: "❓", i18nKey: "liveblog.reactions.generic.question" },
            { id: "exclamation", emoji: "❗", i18nKey: "liveblog.reactions.generic.exclamation" },
            { id: "sad", emoji: "😢", i18nKey: "liveblog.reactions.generic.sad" }
        ] 
    },
    { 
        id: "sports", 
        i18nKey: "liveblog.reactions.sports.title",
        options: [
            { id: "celebration", emoji: "🥳", i18nKey: "liveblog.reactions.generic.celebration" },
            { id: "shocked", emoji: "😱", i18nKey: "liveblog.reactions.generic.shocked" },
            { id: "angry", emoji: "😤", i18nKey: "liveblog.reactions.generic.angry" },
            { id: "raise_hands", emoji: "🙌", i18nKey: "liveblog.reactions.generic.raise_hands" },
            { id: "heart", emoji: "❤️", i18nKey: "liveblog.reactions.generic.heart" },
            { id: "trophy", emoji: "🏆", i18nKey: "liveblog.reactions.generic.trophy" }
        ] 
    },
    { 
        id: "entertainment",
        i18nKey: "liveblog.reactions.entertainment.title",
        options: [
            { id: "love", emoji: "😍", i18nKey: "liveblog.reactions.generic.love" },
            { id: "celebration", emoji: "🥳", i18nKey: "liveblog.reactions.generic.celebration" },
            { id: "star_struck", emoji: "🤩", i18nKey: "liveblog.reactions.generic.star_struck" },
            { id: "grimace", emoji: "😬", i18nKey: "liveblog.reactions.generic.grimace" },
            { id: "mind_blown", emoji: "🤯", i18nKey: "liveblog.reactions.generic.mind_blown" },
            { id: "clap", emoji: "👏", i18nKey: "liveblog.reactions.generic.clap" }
        ] 
    },
    { 
        id: "simple", 
        i18nKey: "liveblog.reactions.simple.title",
        options: [
            { id: "heart", emoji: "❤️", i18nKey: "liveblog.reactions.generic.heart" }
        ] 
    }
];